export default state => {
  return state.limit
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/getters/orderCustomFormLimit.js